import HTTPClient from './http-client';

class UserlogService {

  async registerAccess() {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    return api.put("/userlog_access_updated");
  }

}

export default new UserlogService();
